// Reusable modal functionality
window.PreviewModal = {
  openModals: new Set(),

  open: function (modalId, options = {}) {
    console.log('Opening modal:', modalId, options)
    const modal = document.getElementById(modalId)
    if (!modal) {
      console.error('Modal not found:', modalId)
      return
    }

    console.log('Modal found:', modal)

    // Show loading spinner
    this.showLoading(modal)

    // Handle different content types
    if (options.previewUrl) {
      const iframe = modal.querySelector('iframe')
      if (iframe) {
        // Set up load event listener
        iframe.onload = () => {
          this.hideLoading(modal)
        }

        // Set up error event listener
        iframe.onerror = () => {
          this.hideLoading(modal)
        }

        iframe.src = options.previewUrl
      }
    }

    if (options.title) {
      const titleElement = modal.querySelector('.drawer__title')
      if (titleElement) {
        titleElement.textContent = options.title
      }
    }

    if (options.content) {
      const contentElement = modal.querySelector('.drawer__scrollable')
      if (contentElement) {
        contentElement.innerHTML = options.content
      }
    }

    // Store original body overflow before hiding it
    if (!document.body.dataset.originalOverflow) {
      document.body.dataset.originalOverflow = document.body.style.overflow || 'auto'
    }

    // Show modal by removing hidden attribute and adding classes
    modal.hidden = false
    modal.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'

    // Show overlay and content
    const overlay = modal.querySelector('overlay-element')
    const header = modal.querySelector('.drawer__header')
    const content = modal.querySelector('.drawer__content')

    if (overlay) {
      overlay.classList.remove('invisible', 'opacity-0')
      overlay.classList.add('visible', 'opacity-100')
      overlay.setAttribute('aria-expanded', 'true')
    }

    if (header) {
      header.classList.remove('opacity-0', 'invisible')
      header.classList.add('opacity-100', 'visible')
    }

    if (content) {
      content.classList.remove('opacity-0', 'invisible')
      content.classList.add('opacity-100', 'visible')
    }

    // Track open modal
    this.openModals.add(modal)

    // Add event listeners for closing
    this.addCloseListeners(modal)
  },

  close: function (modal) {
    console.log('Closing modal:', modal)
    const overlay = modal.querySelector('overlay-element')
    const header = modal.querySelector('.drawer__header')
    const content = modal.querySelector('.drawer__content')
    console.log('Closing modal overlay:', overlay)

    if (overlay) {
      overlay.classList.remove('visible', 'opacity-100')
      overlay.classList.add('invisible', 'opacity-0')
      overlay.setAttribute('aria-expanded', 'false')
    }

    if (header) {
      header.classList.remove('opacity-100', 'visible')
      header.classList.add('opacity-0', 'invisible')
    }

    if (content) {
      content.classList.remove('opacity-100', 'visible')
      content.classList.add('opacity-0', 'invisible')
    }

    // Remove from tracking
    this.openModals.delete(modal)

    // Restore original body overflow or completely reset
    const originalOverflow = document.body.dataset.originalOverflow || ''
    document.body.style.overflow = originalOverflow
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    document.body.style.height = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.documentElement.style.overflow = ''
    document.documentElement.style.position = ''

    // Clean up the stored overflow value if no more modals
    if (this.openModals.size === 0) {
      // delete document.body.dataset.originalOverflow
    }

    // Force complete style cleanup and scroll restoration
    setTimeout(() => {
      // Remove all possible blocking styles
      document.body.removeAttribute('style')
      document.documentElement.removeAttribute('style')
      document.body.classList.remove('modal-open', 'no-scroll', 'overflow-hidden', 'has-modal-open', 'has-modal-opening')
      document.documentElement.classList.remove('modal-open', 'no-scroll', 'overflow-hidden')

      // Force scroll capability with important styles
      document.body.style.cssText = 'overflow: auto !important; overflow-y: auto !important; position: static !important;'
      document.documentElement.style.cssText = 'overflow: auto !important; overflow-y: auto !important;'

      // Force scroll event and touch events to work
      document.body.style.touchAction = 'auto'
      document.documentElement.style.touchAction = 'auto'

      // Trigger a scroll event to wake up the scrolling
      // window.dispatchEvent(new Event('resize'))
      // window.dispatchEvent(new Event('scroll'))

      // Final cleanup after ensuring scroll works
      setTimeout(() => {
        if (this.openModals.size === 0) {
          document.body.removeAttribute('style')
          document.documentElement.removeAttribute('style')
        }
      }, 100)
    }, 10)

    // Clean up event listeners
    if (modal._escapeHandler) {
      document.removeEventListener('keydown', modal._escapeHandler)
      modal._escapeHandler = null
    }
    modal._closeListenersAdded = false

    // Hide modal after animation
    setTimeout(() => {
      modal.hidden = true
      modal.setAttribute('aria-hidden', 'true')
    }, 300)
  },

  addCloseListeners: function (modal) {
    const overlay = modal.querySelector('overlay-element')
    const closeButtons = modal.querySelectorAll('.drawer__close')

    // Remove existing listeners to prevent duplicates
    if (modal._closeListenersAdded) return
    modal._closeListenersAdded = true

    // Close on overlay click
    if (overlay) {
      console.log('🚀 ~ overlay:', overlay)
      overlay.addEventListener('click', e => {
        if (e.target === overlay) {
          this.close(modal)
        }
      })
    }

    // Close on any close button click
    closeButtons.forEach(closeButton => {
      closeButton.addEventListener('click', () => {
        this.close(modal)
      })
    })

    // Close on escape key (only for the topmost modal)
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.openModals.has(modal) && !modal.hidden) {
        this.close(modal)
      }
    }

    document.addEventListener('keydown', escapeHandler)
    modal._escapeHandler = escapeHandler
  },

  showLoading: function (modal) {
    const scrollable = modal.querySelector('.drawer__scrollable')
    if (scrollable) {
      // Create loading element if it doesn't exist
      let loadingElement = scrollable.querySelector('.modal-loading')
      if (!loadingElement) {
        loadingElement = document.createElement('div')
        loadingElement.className = 'modal-loading'
        loadingElement.innerHTML = '<div class="loading-spinner-23p5">&nbsp;</div>'
        scrollable.appendChild(loadingElement)
      }
      loadingElement.classList.remove('hidden')
    }
  },

  hideLoading: function (modal) {
    const loadingElement = modal.querySelector('.modal-loading')
    if (loadingElement) {
      loadingElement.classList.add('hidden')
    }
  },

  // Helper method to create a modal programmatically
  createModal: function (id, title, content, options = {}) {
    const modalHtml = `
      <x-modal id="${id}" class="x-modal drawer preview-modal z-30 fixed bottom-0 left-0 h-full w-full pointer-events-none"
        role="dialog"
        aria-modal="true"
        aria-label="${title}"
        hidden
      >
        <overlay-element class="overlay fixed-modal invisible opacity-0 fixed bottom-0 left-0 w-full h-screen pointer-events-none" aria-controls="${id}" aria-expanded="false"></overlay-element>
        <div class="drawer__inner z-10 absolute top-0 flex flex-col w-full h-full overflow-hidden">
          <gesture-element class="drawer__header flex justify-between opacity-0 invisible relative">
            <span class="drawer__title heading title-md">
              ${title}
            </span>
            <button class="button button--secondary button--close drawer__close hidden sm:flex items-center justify-center" type="button" is="hover-button" aria-controls="${id}" aria-expanded="false" aria-label="Close">
              <span class="btn-fill" data-fill></span>
              <span class="btn-text">×</span>
            </button>
          </gesture-element>
          <div class="drawer__content opacity-0 invisible flex flex-col h-full grow shrink">
            <div class="drawer__scrollable relative flex flex-col grow shrink">
              ${options.isIframe ? `<iframe src="" class="w-full h-full border-0"></iframe>` : content}
            </div>
          </div>
        </div>
      </x-modal>
    `

    document.body.insertAdjacentHTML('beforeend', modalHtml)
    return document.getElementById(id)
  },

  // Initialize preview buttons functionality
  init: function () {
    // Simple event delegation approach
    document.addEventListener('click', e => {
      console.log('🚀 ~ Initializing preview modal', e.target)
      // Check if clicked element has data-preview-url
      if (!e.target.hasAttribute('data-preview-url')) return

      e.preventDefault()

      const button = e.target
      const previewUrl = button.getAttribute('data-preview-url')
      const modalId = button.getAttribute('aria-controls')
      const title = button.getAttribute('data-modal-title') || 'Preview Customization'

      console.log('Preview button clicked:', { modalId, previewUrl, title })

      if (modalId && previewUrl) {
        window.PreviewModal.open(modalId, {
          previewUrl: previewUrl,
          title: title
        })
      }
    })
  }
}

// Auto-initialize the modal functionality
window.PreviewModal.init()

// Global debug function for testing
window.testModal = function (modalId, url) {
  console.log('Testing modal:', modalId, url)
  window.PreviewModal.open(modalId, {
    previewUrl: url,
    title: 'Test Modal'
  })
}
